var _ = require('lodash'),
  cache = require('../models/cache'),
  configManager = require('../config/configManager'),
  htmlUtility = require('../utilities/htmlUtility'),
  log = require('../libraries/logger').getLoggerInstance('Base.Main.OrderUtility');

var publicMethods = {
  /**
   * Utility to make sure that a given order object has a given path structure. This can be used to ensure that an order object has the expected structure before
   * modifying or using that order object.
   * 
   * @example
   * ensurePathExists('Consumer.Account', {})
   * -> { Consumer: { Account: {} } }
   * 
   * ensurePathExists('Consumer.Account', { Consumer: { BillingAddress: { FirstName: 'Rick' } } })
   * -> {
   *   Consumer: {
   *     Account: {},
   *     BillingAddress: {
   *       FirstName: 'Rick'
   *     }
   *   }
   * }
   * @param {String} stringPath A period delimited object path that should exist on the order
   * @param {Object} order The order object that is being checked
   * @returns {Object} The modified order object
   */
  ensurePathExists: function (stringPath, order) {
    var pathAsArray = stringPath.split('.'),
      objectPath = [];

    if (order === undefined || typeof order !== 'object') {
      order = {};
    }

    _.each(pathAsArray, function (section) {
      var location = order;

      if (objectPath.length > 0) {
        _.each(objectPath, function (objectKey) {
          location = location[objectKey]
        })
      }

      if (!publicMethods.isObjectValid(section, location)) {
        location[section] = {};
      }

      objectPath.push(section)
    })
    return order;
  },
  /**
   * Helper to validate a key exists within an object and if the key exists to make sure that its value is an object
   * @param {string} key The key to verify is in the parent object
   * @param {Object} parentObject The object to check for the key
   * @returns {Boolean} A flag to indiciate if the object has the expected key as an object
   */
  isObjectValid: function (key, parentObject) {
    if (parentObject !== undefined && key in parentObject && parentObject[key] !== undefined && typeof parentObject[key] === 'object') {
      return true;
    }
    return false;
  },
  MapOrderLocationToEnsure: function (orderLocation) {
    switch (orderLocation) {
      case 'OrderDetails':
        return publicMethods.ensureExists.OrderDetails;
      case 'Consumer.Account':
        return publicMethods.ensureExists.Account;
      case 'Consumer.BillingAddress':
        return publicMethods.ensureExists.BillingAddress;
      case 'Consumer.ShippingAddress':
        return publicMethods.ensureExists.ShippingAddress;
      default:
        log.warn('unknown order location [' + orderLocation + ']')
        break;
    }
  },
  /**
   * Using the cached list of field decorated elements, create an order object
   * @returns {object} The finalized order object
   */
  parseFromCachedElements: function () {
    var order = cache.orderObject;
    try {
      _.each(cache.formFields, function (element, fieldKey) {

        var fieldMappingObject = configManager.getSystemConfig().whiteList.annotatedFields[fieldKey];

        if (fieldMappingObject !== undefined && 'location' in fieldMappingObject) {

          var objectPath = fieldMappingObject.location.split('.'),
            fieldName = fieldMappingObject.fieldName !== undefined ? fieldMappingObject.fieldName : fieldKey,
            location;

          // Ensure our object path exists
          order = publicMethods.ensurePathExists(fieldMappingObject.location, order);

          // Navigate to lowest object location
          location = order
          _.each(objectPath, function (section) {
            location = location[section]
          })

          // Assign the field value
          location[fieldName] = htmlUtility.val(element);

        }
      })

      cache.orderObject = order;

    } catch (error) {
      log.error('Failed to auto parse cachced fields into an order object' + error)
    }
    return order;
  }
};

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./utilities/orderUtility.js
// module id = 74
// module chunks = 5